// extracted by mini-css-extract-plugin
export var copyableField = "_rx-4";
export var customerBadge = "_rx-0";
export var customerInfoTitle = "_rx-2";
export var details = "_rx-1";
export var dropdownContainer = "_rx-5";
export var dropdownImage = "_rx-6";
export var editAssigneeForm = "_rx-a";
export var editButton = "_rx-3";
export var email = "_rx-7";
export var hidden = "_rx-d";
export var input = "_rx-8";
export var saveButton = "_rx-b";
export var shopifyIcon = "_rx-c";
export var suggestionBadge = "_rx-e";
export var suggestionText = "_rx-f";
export var username = "_rx-9";